<template>
	<transition name="slide-fade">
		<div
			class="cell"
			@click="toggled = !toggled"
			:class="{ toggled: toggled === true }"
		>
			<span class="content" v-if="text && toggled === false" v-html="truncate(text, 35, '...')"></span>
			<span class="content" v-else-if="text && toggled === true" v-html="text"></span>
			<span class="content" v-else>Something went wrong.</span>

			<span class="indicator closed" v-if="text && toggled === false"
				>&#8964;</span
			>
			<span class="indicator" v-else-if="text && toggled === true"
				>&times;</span
			>
			<span class="indicator" v-else>?</span>
		</div>
	</transition>
</template>

<script>
export default {
	data() {
		return {
			toggled: false,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		text: {
			type: String,
		},
	},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		truncate(text, length, clamp) {
			clamp = clamp || '...';
			var node = document.createElement('div');
			node.innerHTML = text;
			var content = node.textContent;
			return content.length > length
				? content.slice(0, length) + clamp
				: content;
		},
	},

	filters: {
		truncate(text, length, clamp) {
			clamp = clamp || '...';
			var node = document.createElement('div');
			node.innerHTML = text;
			var content = node.textContent;
			return content.length > length
				? content.slice(0, length) + clamp
				: content;
		},
	},

	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.cell {
	grid-column: span 1;
	max-height: 40px;
	overflow-y: hidden;
	// transition: 0.2s all ease-in-out;
	background: lighten($edc-charcoal, 85);
	padding: 10px;
	position: relative;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;

	&:hover {
		cursor: pointer;
		background: lighten($edc-charcoal, 80);
	}

	&.toggled {
		max-height: 1000px;
	}

	.content {
		width: calc(100% - 20px);
	}

	.indicator {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: $edc-red;
		position: absolute;
		bottom: 10px;
		right: 10px;
		font-size: 1.5rem;
		width: 20px;

		&.closed {
			height: calc(100% - 20px);
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/CareersListCell.vue